(function () {
  var KEY = 'em_wishlist_v1';

  function getCount() {
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) return 0;

      var data = JSON.parse(raw);
      if (Array.isArray(data)) return data.length;
      if (data && Array.isArray(data.items)) return data.items.length;
      if (data && Array.isArray(data.products)) return data.products.length;
      if (data && typeof data === 'object') return Object.keys(data).length;

      return 0;
    } catch (e) {
      return 0;
    }
  }

  function render(count) {
    var badges = document.querySelectorAll('[data-em-wishlist-badge]');
    if (!badges.length) return;

    badges.forEach(function (badge) {
      if (count > 0) {
        badge.textContent = count > 9 ? '9+' : String(count);
        badge.style.display = 'inline-flex';
      } else {
        badge.textContent = '';
        badge.style.display = 'none';
      }
    });
  }

  function refresh() {
    render(getCount());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }

  window.addEventListener('em:wishlist:changed', refresh);
  window.addEventListener('pageshow', refresh);

  window.addEventListener('storage', function (e) {
    if (!e.key || e.key === KEY) refresh();
  });

  window.emWishlistBadgeRefresh = refresh;
})();